import React from 'react'
import WrapperInput, { IWrapperInput } from './WrapperInput';
import { FormControlLabel, FormHelperText, Radio, RadioGroup, Stack, SxProps } from '@mui/material';

interface IRadiosInput extends Omit<IWrapperInput, "children"> {
    errorMessage?: string | undefined;
    options: {label: string, value: string}[]
    groupSx?: SxProps
    row?: boolean
    defaultValue?: string
    value?: string
    onChange?: (val: string) => void
  }

function RadiosInput({id, label, required, labelWidth, options, groupSx, row = true,
    errorMessage,
    defaultValue,
    value,
    onChange,
    ...wrapperProps}: IRadiosInput) {
  return (
    <WrapperInput
      id={id}
      label={label}
      required={required}
      labelWidth={labelWidth}
      {...wrapperProps}
    >
      <Stack>
        <RadioGroup
          row={row}
          defaultValue={defaultValue}
          value={value}
          onChange={(_, value) => {
            onChange?.(value);
          }}
          sx={{ ...groupSx }}
        >
          {options.map((option) => {
            return (
              <FormControlLabel
                key={option.value}
                label={option.label}
                value={option.value}
                sx={{
                  "& .MuiFormControlLabel-label": { color: "text.secondary" },
                }}
                control={<Radio size="medium" />}
              />
            );
          })}
        </RadioGroup>
        {errorMessage && (
          <FormHelperText error sx={{ mx: 1.75, fontStyle: "italic" }}>
            {errorMessage}
          </FormHelperText>
        )}
      </Stack>
    </WrapperInput>
  );
}

export default RadiosInput